// RITA-1541: Kennung des Browserfensters für die Bearbeitungssperre. Sie liegt je Vorlage im
// sessionStorage, der pro Tab gilt und ein Neuladen (F5) überlebt: Dasselbe Fenster hält nach dem
// Neuladen dieselbe Sperre, ein zweites Fenster (eigener sessionStorage) bekommt eine andere Kennung.
const SCHLUESSEL = 'prm.vertragsvorlage.fensterkennung.';

export function neueFensterkennung(): string {
  const krypto = typeof crypto !== 'undefined' ? crypto : undefined;
  if (krypto?.randomUUID) return krypto.randomUUID();
  // Ersatz ohne Web Crypto (ältere Testumgebungen): 32 zufällige Hexzeichen in UUID-Form.
  const hex = Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function speicher(): Storage | null {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
}

/** Gespeicherte Kennung dieses Fensters für die Vorlage oder null. */
export function fensterkennungLesen(vorlagenId: number): string | null {
  try {
    return speicher()?.getItem(`${SCHLUESSEL}${vorlagenId}`) ?? null;
  } catch {
    return null;
  }
}

/** Kennung für die Vorlage in diesem Fenster merken; ohne Speicher bleibt sie nur im Arbeitsspeicher. */
export function fensterkennungMerken(vorlagenId: number, kennung: string): void {
  try {
    speicher()?.setItem(`${SCHLUESSEL}${vorlagenId}`, kennung);
  } catch {
    // Ohne sessionStorage (z. B. privater Modus mit Sperre) gilt die Kennung nur bis zum Neuladen.
  }
}

/** Vorhandene Kennung wiederverwenden, sonst eine neue anlegen und merken. */
export function fensterkennungFuer(vorlagenId: number): string {
  const vorhanden = fensterkennungLesen(vorlagenId);
  if (vorhanden) return vorhanden;
  const neu = neueFensterkennung();
  fensterkennungMerken(vorlagenId, neu);
  return neu;
}
